/**
 * KML template download utility.
 *
 * Generates a sample .kml file with a valid polygon and triggers a browser download.
 */

const KML_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>Plantilla Parcela de Referencia</name>
    <Placemark>
      <name>Parcela Ejemplo</name>
      <Polygon>
        <outerBoundaryIs>
          <LinearRing>
            <coordinates>
              -0.5,39.5,0 -0.49,39.5,0 -0.49,39.51,0 -0.5,39.51,0 -0.5,39.5,0
            </coordinates>
          </LinearRing>
        </outerBoundaryIs>
      </Polygon>
    </Placemark>
  </Document>
</kml>`;

export const downloadKMLTemplate = (): void => {
  const blob = new Blob([KML_TEMPLATE], { type: "application/vnd.google-earth.kml+xml" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "plantilla_parcela.kml";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};
